import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Popover, ArrowContainer } from "@toddle-edu/react-tiny-popover";
import classNames from "classnames";
import moment from "moment";
import { useI18n } from "Hooks";
import { colors } from "Constants";
import classes from "./SelectedDatesPopover.scss";
import { Tooltip } from "@toddle-edu/ds-web";

// Format the class list based on activeKey
const getFormattedClassList = ({ courseClassList, classDates }) => {
  return _.map(classDates, ({ classId, startDate, endDate }) => {
    const associatedClass = _.find(courseClassList, { id: classId });
    const title = _.get(associatedClass, "title", "");
    const startDateFormatted = moment(startDate).format("DD MMM YYYY");
    const endDateFormatted = moment(endDate).format("DD MMM YYYY");
    return {
      classLabel: title,
      date: `${startDateFormatted} - ${endDateFormatted}`,
    };
  });
};

const SelectedDatesPopover = ({
  courseClassList,
  handlePopoverClose,
  nodeRef,
  classDates,
  isOpen,
}) => {
  const { t } = useI18n(["unitPlan"]);
  const [classDateList, setClassDateList] = useState([]);

  useEffect(() => {
    const formattedList = getFormattedClassList({
      classDates,
      courseClassList,
    });
    setClassDateList(formattedList);
  }, [classDates]);

  return (
    <Popover
      isOpen={isOpen}
      positions={["bottom"]}
      reposition
      onClickOutside={handlePopoverClose}
      childrenRef={{ current: nodeRef }}
      isChildrenRefPassed
      containerClassName={classes.popoverContainer}
      content={props => {
        const { position, childRect, popoverRect, nudgedTop } = props;
        if (nudgedTop > 120 || nudgedTop < -120) {
          handlePopoverClose();
        }
        return (
          <ArrowContainer
            position={position}
            childRect={childRect}
            popoverRect={popoverRect}
            arrowColor={colors.white}
            arrowSize={12}
          >
            <div className={classes.container}>
              <h6 className={classNames()}>
                {t("unitPlan:unit_duration_label")}
              </h6>
              {_.map(classDateList, ({ classLabel, date }, index) => (
                <div key={index} className={classes.classListContainer}>
                  <Tooltip
                    tooltip={classLabel}
                    visible={_.size(classLabel) > 15}
                    showArrow={true}
                    placement="top"
                    overlayStyle={{ zIndex: 1501 }}
                  >
                    <span
                      className={classNames(
                        "text-label",
                        classes.classLabelText,
                        "truncate"
                      )}
                    >
                      {classLabel}
                    </span>
                  </Tooltip>
                  <span className="text-body">{date}</span>
                </div>
              ))}
            </div>
          </ArrowContainer>
        );
      }}
    />
  );
};

export default SelectedDatesPopover;
